module.exports = __webpack_public_path__ + "static/media/un3373.3c4eb3af.jpg";